import * as core from '../../../../../../../core'

import { query } from './delete-award.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.actions.delete-award',
    description: 'Delete Award',
    name: 'Delete Award',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
